<template>
  <div id="order-type-select">
    <b-row class="justify-content-center">
      <b-col
        cols="12"
        lg="8"
      >
        <b-card>
          <div class="text-center mb-50">
            <h2 class="h4 mb-1">
              {{ $t('order.create.select-type-title') }}
            </h2>
            <p class="text-muted mb-0">
              {{ $t('order.create.select-type-description') }}
            </p>
          </div>
          <p class="text-muted text-center mb-2 font-small-2">
            {{ $t('order.create.locked-hint') }}
          </p>
          <b-row>
            <b-col
              v-for="type in orderTypes"
              :key="type"
              cols="12"
              md="6"
              class="mb-1"
            >
              <b-button
                block
                variant="outline-primary"
                class="d-flex align-items-center justify-content-center"
                :disabled="isLoading && loadingType !== type"
                @click="selectType(type)"
              >
                <b-spinner
                  v-if="isLoading && loadingType === type"
                  small
                  class="mr-50"
                />
                <span class="d-inline-flex align-items-center">
                  {{ $t(`order.types.${type}`) }}
                  <feather-icon
                    v-if="typeHelpTexts[type]"
                    v-b-tooltip.hover="typeHelpTexts[type]"
                    icon="InfoIcon"
                    class="ml-50"
                  />
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { parseRequestError } from '@/helpers/helpers'
import orderTypes from '@/dictionaries/orderTypes'
import orderEventKinds from '@/dictionaries/orderEventKinds'
import { VBTooltip } from 'bootstrap-vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      loadingType: null,
    }
  },
  computed: {
    orderTypes() {
      return orderTypes
    },
    typeHelpTexts() {
      return {
        [orderTypes.multi_transport]: this.$t('order.create.type-help.multi_transport'),
        [orderTypes.medical_courier]: this.$t('order.create.type-help.medical_courier'),
        [orderTypes.event]: this.$t('order.create.type-help.event'),
      }
    },
    isLoading() {
      return this.loadingType !== null
    },
  },
  methods: {
    selectType(type) {
      if (this.isLoading) {
        return
      }

      this.loadingType = type
      const payload = {
        type,
      }

      if (type === orderTypes.event) {
        payload.eventKind = orderEventKinds.medical_coverage
      }

      this.$store.dispatch('order/addOrder', payload)
        .then(res => {
          this.$router.push({
            name: 'order-edit',
            params: { id: res.data.id },
            query: { ...this.$route.query },
          })
        })
        .catch(err => parseRequestError(err))
        .finally(() => {
          this.loadingType = null
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#order-type-select {
  min-height: calc(100vh - 13rem);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
